<template>
  <b-container fluid class="mt-4">
    <h1 align="center">Welcome</h1>
    </br>
    </br>
    <div v-if="this.user !== null">Your <b>Partner ID</b> is: <b>{{ this.user.uid }}</b></div>
    <div v-if="this.user !== null">To learn how to integrate your pages check  <a href="/static/JS_Code_Installation guide-1.2.pdf" download>this guide</a>.</div>
    </br>
    <div v-if="this.user !== null">
      <b-row>
        <b-col cols=3>
      <h5><b>Thematics</b></h5>
      <b-table small striped hover bordered :items="items"></b-table>
      </b-col>
      <b-col cols=6>
      </b-col>
      </b-row>
      </div>
  </b-container>
</template>

<script>
export default {
  name: "SetupInfo",
  data() {
    return {
      user: null,
      items: [
        { offer_thematic_name: "Adult", id: "1" },
        { offer_thematic_name: "Dating", id: "2" },
        { offer_thematic_name: "Finance - Crypto", id: "3" },
        { offer_thematic_name: "Finance - Trading", id: "4" },
        { offer_thematic_name: "Gambling - Betting", id: "5" },
        { offer_thematic_name: "Gambling - Casino", id: "6" },
        { offer_thematic_name: "Games", id: "7" },
        { offer_thematic_name: "Live Streaming - Sports", id: "8" },
        { offer_thematic_name: "Nutra", id: "9" },
        { offer_thematic_name: "Shopping", id: "10" },
        { offer_thematic_name: "Streaming - Video/TV", id: "11" },
        { offer_thematic_name: "Sweepstakes", id: "12" },
        { offer_thematic_name: "VPN", id: "13" },
        { offer_thematic_name: "PIN Submit", id: "14" },
      ],
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      }
    });
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/SetupInfo.vue